<template>
  <v-dialog v-model="show" max-width="500px">
    <v-card>
      <v-card-title>{{ $t("tasks.edit_task") }}</v-card-title>

      <v-card-text>
        <v-select
          v-if="task"
          :items="taskStatuses"
          v-model="editableStatus"
          item-text="text"
          item-value="id"
          return-object
          :label="$t('billings.status')"
          clearable
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey lighten-2" @click="close">
          {{ $t("cancel") }}
          <v-icon dark right> mdi-keyboard-return </v-icon>
        </v-btn>
        <v-btn color="success" @click="save">
          {{ $t("save") }}
          <v-icon dark right> mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { API_BASE_URL } from "@/config";
import axios from "@/plugins/axios";

export default {
  name: "EditTaskDialog",
  props: {
    show: Boolean,
    task: Object,
    taskStatuses: Array,
  },
  data() {
    return {
      editableStatus: null,
    };
  },
  watch: {
    task: {
      immediate: true,
      handler(newTask) {
        if (newTask) {
          this.editableStatus = newTask.status;
        }
      },
    },
  },
  methods: {
    save() {
      let data = {
        status_id:
          typeof this.editableStatus == "object"
            ? this.editableStatus.id
            : this.editableStatus,
      };
      axios
        .put(API_BASE_URL + "/tasks/" + this.task.id, data, {
          headers: this.header,
        })
        .then((data) => {
          this.$toast.success(
            this.$t(
              "vehicles.clients_model.text_messages.client_added_successfully"
            )
          );
          this.cancelDialog("added", data.data.data);
        })
        .catch(() => {})
        .finally(() => {
          this.$emit("save", {
            ...this.task,
            status: { ...this.task.status, id: this.editableStatus },
          });
          this.close();
        });
    },
    close() {
      this.$emit("update:show", false);
    },
  },
};
</script>
